import { twdClass } from "../../../constants/tailwind.constants";
import { INPUT_TEXT } from "../../../constants/var.constants";
import { cloneDeep, set } from "lodash";


const Ads = ({ sitesettings, updateSettings }) => {
  const updateItem = (value) => {
    const sst = cloneDeep(sitesettings);
    const data = set(sst, "ads", value);
    updateSettings(data);
  };

  return (
    <div className={twdClass("w-full mb-4")}>
      <div className={twdClass(" mb-4")}>
        <span className={twdClass("text-md font-semibold mr-4")}>Ads.txt</span>
        <a target="_blank" className={twdClass("text-sm underline opacity-50")} href="https://support.google.com/adsense/answer/12171612?hl=en">Check guide</a>
      </div>
      <textarea
        rows={10}
        value={sitesettings.ads}
        className={twdClass(`${INPUT_TEXT} w-full`)}
        onChange={(e) => updateItem(e.target.value)}
        placeholder = {`google.com, pub-0000000000000000, DIRECT, f08c47fec0942fa0`}
      ></textarea>
    </div>
  );
};

export default Ads;
